<nz-card style="width:100%;" [nzBordered]="false" [nzTitle]="'查询表格'" [nzExtra]="tableToolbar">
  <ng-content></ng-content>
</nz-card>
<ng-template #tableToolbar>
  <div class="ant-pro-table-toolbar">
    <div class="ant-pro-table-toolbar-option" *ngIf="needAddBtn">
      <button nz-button  class="addBtn"  *appAuth="actionCode.add" (click)="addBtnClick()">
        <i nz-icon nzType="plus" nzTheme="outline"></i>
        新增
      </button>
    </div>
    <div class="ant-pro-table-toolbar-default-option">
      <nz-divider nzType="vertical"></nz-divider>
      <nz-space [nzSize]="16" nzDirection="horizontal">
        <i nz-icon *nzSpaceItem nzType="column-width" nzTheme="outline"></i>
        <i nz-icon *nzSpaceItem nzType="fullscreen" nzTheme="outline"></i>
        <i nz-icon *nzSpaceItem nzType="setting" nzTheme="outline"></i>
      </nz-space>
    </div>
  </div>
</ng-template>
